// Known top-level app route prefixes that the legacy gallery-slug redirects
// (/:slug and /:slug/:gifId) must NOT treat as channel slugs. If an
// (unauthenticated) user hits e.g. /admin or /admin/users, the slug wildcards
// would otherwise redirect them into /ch/admin(/users) instead of letting the
// real route — and its unauthenticated → /sign-in guard — apply.
//
// Single source of truth shared by BOTH LegacyChannelRedirect (/:slug) and
// LegacyGifRedirect (/:slug/:gifId). Keeping one set avoids the drift that let
// /admin/users fall through the two-segment redirect — "admin" had been added
// to the one-segment set only.
// RETIRED-BUT-RETAINED: "memento-plan", "nice-choice" and "analytics" no longer
// have routes — the dead Memento self-serve checkout was removed, and so was the
// analytics page that iframed a rails route rails had deleted. They stay in this
// set on purpose. Without them the slug wildcards would capture the retired URLs
// (a bookmarked /analytics/:id included) and redirect them to a bogus gallery
// lookup under /ch/; retained, they land on "/" (→ /channels authed, /sign-in
// unauthed). Do not prune.
export const APP_ROUTES = new Set([
  "channels",
  "account",
  "memento-plan",
  "nice-choice",
  "terms",
  "leads",
  "analytics",
  "admin",
  "sign-in",
  "sign-up",
  "forgot-password",
  "api",
  "ch",
  "moves",
]);
